import { render } from "./DropdownButton.vue?vue&type=template&id=32a9973f&scoped=true"
import script from "./DropdownButton.vue?vue&type=script&lang=js"
export * from "./DropdownButton.vue?vue&type=script&lang=js"

import "./DropdownButton.vue?vue&type=style&index=0&id=32a9973f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a9973f"]])

export default __exports__